import { INotesAction } from '@engoo/realtime-protocol/notes';

import { tFunctionType } from 'app/services/localization';
import { OTDocumentManager, IOTActionHandler } from 'app/services/rtc/sync/documentmanagers/ot';
import { OTTextActionHandler } from 'app/services/rtc/sync/string';
import { IDocumentManagerState } from 'app/containers/rtc/DocumentProvider/useDocumentManager';
import { IDocumentManagerFactory } from 'app/services/rtc/sync/DocumentSpec';
import { Stream } from '@engoo/realtime-protocol/stream';

type NotesManager = OTDocumentManager<string, INotesAction>;
export type NotesDocumentManagerState = IDocumentManagerState<string, NotesManager>;

const managerType: IDocumentManagerFactory<
  string,
  INotesAction,
  IOTActionHandler<string, INotesAction>,
  NotesManager
> = OTDocumentManager;

export const NotesDocumentSpec = {
  managerType,
  actionHandler: new OTTextActionHandler(),
  initialState:  '',
  name: (t: tFunctionType) => t('rtc.features.notes.name'),
};

export default {
  [Stream.Notes]: NotesDocumentSpec,
};
